export const LABELS = {
    analysisStart: 'Start date',
    developmentStartDate: 'Construction start',
    developmentEndDate: 'Construction end',
    operationStartDate: 'Operation start',
    firstStabilizedMonth: '1st stabilized month',
    saleMonth: 'Sale month',
    firstUnitDelivered: '1st unit delivered',
    constructionPeriod: 'Construction',
};

export const ROW_HEIGHT = 60;
export const TIMELINE_SCROLL_THRESHOLD = 200;
export const BASE_CHART_WIDTH = 1200;
